import React, { FC } from 'react';
import { Box, Icon, Table, Text } from '@chakra-ui/react';
import { LuCheck } from 'react-icons/lu';
import { countriesForPlan } from '@/data/plans';

interface Row {
  label: string;
  lite: string;
  plus: string;
  enterprise: string;
}

const ROWS: Row[] = [
  { label: 'Documents / month', lite: '100', plus: '1,000', enterprise: 'Unlimited' },
  { label: 'Archive storage', lite: '1 GB', plus: '2 GB', enterprise: 'Custom' },
  { label: 'Unlimited users', lite: '✓', plus: '✓', enterprise: '✓' },
  { label: 'Legal compliance archiving', lite: '✓', plus: '✓', enterprise: '✓' },
  { label: 'CSV upload with mapping tool', lite: '✓', plus: '✓', enterprise: '✓' },
  { label: 'Manual invoice & credit note creation', lite: '✓', plus: '✓', enterprise: '✓' },
  { label: 'Automated daily reports', lite: '—', plus: '✓', enterprise: '✓' },
  { label: 'API access', lite: '—', plus: '✓', enterprise: '✓' },
  { label: 'AI error handling', lite: '—', plus: '✓', enterprise: '✓' },
  { label: 'Real-time translation', lite: '—', plus: '—', enterprise: '✓' },
  { label: 'Access to tax experts', lite: '—', plus: '—', enterprise: '✓' },
  { label: 'Single sign-on (SSO)', lite: '—', plus: '—', enterprise: '✓' },
  { label: 'Multi-entity management', lite: '—', plus: '—', enterprise: '✓' }
];

const rows = (): Row[] => [
  {
    label: 'Countries included',
    lite: `${countriesForPlan('Lite').length} countries`,
    plus: `${countriesForPlan('Plus').length} countries`,
    enterprise: 'All'
  },
  ...ROWS
];

const Cell: FC<{ value: string }> = ({ value }) => {
  if (value === '✓') {
    return (
      <Icon color='brand.500' aria-label='Included'>
        <LuCheck />
      </Icon>
    );
  }
  return <Text as='span' color={value === '—' ? 'fg.muted' : 'fg'}>{value}</Text>;
};

const PricingTable: FC = () => (
  <Box overflowX='auto'>
    <Table.Root size='sm' striped>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader>Feature</Table.ColumnHeader>
          <Table.ColumnHeader textAlign='center' fontWeight='bold' color='fg'>
            Lite
          </Table.ColumnHeader>
          <Table.ColumnHeader textAlign='center' fontWeight='bold' color='brand.500'>
            Plus
          </Table.ColumnHeader>
          <Table.ColumnHeader textAlign='center' fontWeight='bold' color='fg'>
            Enterprise
          </Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {rows().map((r) => (
          <Table.Row key={r.label}>
            <Table.Cell>
              <Text>{r.label}</Text>
            </Table.Cell>
            <Table.Cell textAlign='center'>
              <Cell value={r.lite} />
            </Table.Cell>
            <Table.Cell textAlign='center'>
              <Cell value={r.plus} />
            </Table.Cell>
            <Table.Cell textAlign='center'>
              <Cell value={r.enterprise} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  </Box>
);

export default PricingTable;
